if (!customElements.get('sonic-longfill-mix')) {
  customElements.define('sonic-longfill-mix', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.addMix.bind(this));
    }

    async addMix(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;
      const error = this.querySelector('[role="alert"]');
      const status = this.querySelector('.sonic-mix-status');
      error.hidden = true;
      status.textContent = '';
      const quantity = Number(this.form.elements.quantity.value);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      const selection = new FormData(this.form);
      const items = [];
      for (const name of ['vg', 'nic']) {
        const id = selection.get(name);
        if (id) items.push({ id: Number(id), quantity });
      }
      if (event.submitter?.value === 'together') {
        const main = document.querySelector('[id^="MainProduct-"]');
        const productForm = main?.querySelector('product-form form');
        const submit = productForm?.querySelector('[type="submit"]');
        if (!productForm || submit?.disabled || submit?.getAttribute('aria-disabled') === 'true' || !productForm.reportValidity()) {
          error.textContent = 'Please select an available longfill variant above, or use Add extras only.';
          error.hidden = false;
          return;
        }
        const data = new FormData(productForm);
        const id = Number(data.get('id'));
        if (!Number.isSafeInteger(id) || id < 1) return;
        const longfill = { id, quantity };
        const properties = {};
        for (const [key, value] of data) {
          const match = key.match(/^properties\[(.*)\]$/);
          if (match) properties[match[1]] = value;
        }
        if (Object.keys(properties).length) longfill.properties = properties;
        if (data.get('selling_plan')) longfill.selling_plan = data.get('selling_plan');
        items.unshift(longfill);
      }
      if (!items.length) {
        error.textContent = 'Choose at least one extra to add.';
        error.hidden = false;
        return;
      }
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      const buttons = this.querySelectorAll('button');
      buttons.forEach(button => { button.disabled = true; });
      status.textContent = 'Adding your selection…';
      try {
        const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items };
        if (cartEl) {
          body.sections = cartEl.getSectionsToRender().map(section => section.id).join(',');
          body.sections_url = window.location.pathname;
        }
        const response = await fetch(this.dataset.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Your selection could not be added. Please check availability and try again.');
        status.textContent = '';
        if (cartEl && result.sections) {
          const last = result.items ? result.items[result.items.length - 1] : result;
          cartEl.cartItemKey = last.key;
          cartEl.renderContents(Object.assign({}, result, { key: last.key }));
        } else {
          window.location.assign(this.dataset.cartUrl);
        }
      } catch (failure) {
        error.textContent = failure.message || 'Could not confirm the cart update. Check your cart before trying again.';
        error.hidden = false;
        status.textContent = '';
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        buttons.forEach(button => { button.disabled = false; });
      }
    }
  });
}
